import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { Register } from '@xanadu/core';

@Component({
    selector: 'app-image-meta',
    templateUrl: './image-meta.component.html',
    styleUrls: ['./image-meta.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
@Register('image-meta')
export class ImageMetaComponent {
    model = input<any>();

    metaPattern: any = { id: 'pattern', name: 'Image Pattern' };
}
